.lod-cards {
  display: flex;
  flex-direction: column;
  text-align: initial;

  .pager {
    margin-top: 40px;

    &__items {
      justify-content: center !important;
    }
  }

  .results-text {
    margin-bottom: 20px;
  }

  .cta-btn {
    align-self: flex-start;
    font-size: 16px;
    line-height: 24px;
    margin-left: 30px;
    top: -20px;
    display: inline-flex;
    align-items: center;

    &:before {
      content: url('data:image/svg+xml,<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M17.25 19.5C16.4227 19.5 15.75 18.8272 15.75 18C15.75 17.1727 16.4227 16.5 17.25 16.5C18.0773 16.5 18.75 17.1727 18.75 18C18.75 18.8272 18.0773 19.5 17.25 19.5ZM6.75 13.5C5.92275 13.5 5.25 12.8273 5.25 12C5.25 11.1727 5.92275 10.5 6.75 10.5C7.57725 10.5 8.25 11.1727 8.25 12C8.25 12.8273 7.57725 13.5 6.75 13.5ZM17.25 4.5C18.0773 4.5 18.75 5.17275 18.75 6C18.75 6.82725 18.0773 7.5 17.25 7.5C16.4227 7.5 15.75 6.82725 15.75 6C15.75 5.17275 16.4227 4.5 17.25 4.5ZM17.25 14.25C16.1775 14.25 15.2168 14.7052 14.5335 15.4268L10.449 12.5092C10.4715 12.3412 10.5 12.174 10.5 12C10.5 11.823 10.4715 11.6543 10.4482 11.484L14.4915 8.5215C15.177 9.2715 16.1543 9.75 17.25 9.75C19.3207 9.75 21 8.07075 21 6C21 3.92925 19.3207 2.25 17.25 2.25C15.1792 2.25 13.5 3.92925 13.5 6C13.5 6.14625 13.527 6.28575 13.5435 6.4275L9.45975 9.4185C8.7765 8.70225 7.818 8.25 6.75 8.25C4.67925 8.25 3 9.92925 3 12C3 14.0708 4.67925 15.75 6.75 15.75C7.8225 15.75 8.78325 15.2948 9.4665 14.5732L13.551 17.4907C13.5285 17.6587 13.5 17.826 13.5 18C13.5 20.0707 15.1792 21.75 17.25 21.75C19.3207 21.75 21 20.0707 21 18C21 15.9292 19.3207 14.25 17.25 14.25Z" fill="%23005BA9"/><mask id="mask0_1173_583" style="mask-type:luminance" maskUnits="userSpaceOnUse" x="3" y="2" width="18" height="20"><path fill-rule="evenodd" clip-rule="evenodd" d="M17.25 19.5C16.4227 19.5 15.75 18.8272 15.75 18C15.75 17.1727 16.4227 16.5 17.25 16.5C18.0773 16.5 18.75 17.1727 18.75 18C18.75 18.8272 18.0773 19.5 17.25 19.5ZM6.75 13.5C5.92275 13.5 5.25 12.8273 5.25 12C5.25 11.1727 5.92275 10.5 6.75 10.5C7.57725 10.5 8.25 11.1727 8.25 12C8.25 12.8273 7.57725 13.5 6.75 13.5ZM17.25 4.5C18.0773 4.5 18.75 5.17275 18.75 6C18.75 6.82725 18.0773 7.5 17.25 7.5C16.4227 7.5 15.75 6.82725 15.75 6C15.75 5.17275 16.4227 4.5 17.25 4.5ZM17.25 14.25C16.1775 14.25 15.2168 14.7052 14.5335 15.4268L10.449 12.5092C10.4715 12.3412 10.5 12.174 10.5 12C10.5 11.823 10.4715 11.6543 10.4482 11.484L14.4915 8.5215C15.177 9.2715 16.1543 9.75 17.25 9.75C19.3207 9.75 21 8.07075 21 6C21 3.92925 19.3207 2.25 17.25 2.25C15.1792 2.25 13.5 3.92925 13.5 6C13.5 6.14625 13.527 6.28575 13.5435 6.4275L9.45975 9.4185C8.7765 8.70225 7.818 8.25 6.75 8.25C4.67925 8.25 3 9.92925 3 12C3 14.0708 4.67925 15.75 6.75 15.75C7.8225 15.75 8.78325 15.2948 9.4665 14.5732L13.551 17.4907C13.5285 17.6587 13.5 17.826 13.5 18C13.5 20.0707 15.1792 21.75 17.25 21.75C19.3207 21.75 21 20.0707 21 18C21 15.9292 19.3207 14.25 17.25 14.25Z" fill="white"/></mask><g mask="url(%23mask0_1173_583)"></g></svg>');
      width: 24px;
      height: 24px;
      margin-left: 0;
      border-bottom: 0;
      position: absolute;
      left: -30px;
      vertical-align: middle;
      display: inline-block;
    }
  }

  .filter__results {
    margin-left: 0;
    margin-bottom: 0;
  }

  #previous,
  #next {
    cursor: pointer;
    display: block;
  }
}
